function WhatYouLearnSection({ items }) {
  return (
    <section className="rounded-xl border border-[#1A87CC]/40 bg-gradient-to-r from-[#C5E4FF] to-[#EDC7FF] px-6 py-6 shadow-[0_4px_16px_rgba(0,0,0,0.05)] sm:px-10 sm:py-8">
      <h2 className="text-center text-lg font-bold text-[#1B1B1B]">What You Learn</h2>
      <ul className="mt-6 grid grid-cols-1 gap-x-8 gap-y-4 sm:grid-cols-2">
        {items.map((item) => (
          <li key={item} className="flex items-start gap-3">
            <svg
              className="mt-0.5 h-5 w-5 shrink-0 text-[#1A87CC]"
              fill="currentColor"
              viewBox="0 0 20 20"
              aria-hidden
            >
              <path
                fillRule="evenodd"
                d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                clipRule="evenodd"
              />
            </svg>
            <span className="text-sm font-medium leading-snug text-[#1B1B1B]">{item}</span>
          </li>
        ))}
      </ul>
    </section>
  );
}

export default WhatYouLearnSection;
